<template>
  <div>
    <div>
      <div class="event-label-title">
        <label
          @click="step++"
          v-show="step === -1"
          class="event-title-label-box event-title-label-box-hover font14 mr16"
          ><p class="back_icon icon-portal-arrows-right"></p>
          <p>交互列表</p></label
        >
        <label
          @click="backStep(-1)"
          v-show="step === 0"
          class="event-title-label-box event-title-label-box-hover font14 mr16"
          ><p v-if="tarEvent !== null" class="back_icon icon-portal-arrows-left"></p>
          <p>新建交互事件</p></label
        >
        <label
          @click="backStep(0)"
          v-show="step === 1"
          class="event-title-label-box event-title-label-box-hover font14 mr16"
          ><p class="back_icon icon-portal-arrows-left"></p>
          <p>交互动作设置</p></label
        >
        <label
          @click="backStep(1)"
          v-show="step === 2"
          class="event-title-label-box event-title-label-box-hover font14 mr16"
          ><p class="back_icon icon-portal-arrows-left"></p>
          <p>
            {{ eventOptions.step1.subEventType.eventMovement === "window" ? "页面事件设置" : "选择响应组件" }}
          </p></label
        >
        <label
          @click="backStep(2)"
          v-show="step === 3"
          class="event-title-label-box event-title-label-box-hover font14 mr16"
          ><p class="back_icon icon-portal-arrows-left"></p>
          <p>事件交互设置</p></label
        >
      </div>
      <editEvent
        :componentVariables.sync="eventOptions.step0.componentVariables"
        v-show="step === -1"
        :tarEvent="tarEvent"
        :primarySelectValue="primarySelectValue"
        @createEvent="createEventEv"
        @editEvent="editEventEv"
      />
      <chooseEvent
        v-show="step === 0"
        :publishIds="{ ...activeRectIdsFilter(activeRectIds) }"
        :eventName.sync="eventOptions.step0.eventName"
        :componentVariables.sync="eventOptions.step0.componentVariables"
        :variableTag.sync="eventOptions.step0.variableTag"
        @next="() => step++"
      />
      <eventSetting
        v-if="step === 1"
        :eventName="eventOptions.step0.eventName"
        :eventMovement.sync="eventOptions.step1.subEventType.eventMovement"
        :movementType.sync="eventOptions.step1.subEventType.movementType"
        :eventVariables.sync="eventOptions.step1.eventVariables"
        :componentVariables="eventOptions.step0.componentVariables"
      />
      <chooseResponseComponent
        v-if="step === 2 && eventOptions.step1.subEventType.eventMovement === 'component'"
        :responseRectIds.sync="eventOptions.step2ByComponent.responseRectIds"
        :innerElementLabel.sync="innerElementLabel"
      />
      <setWindowResponse
        v-if="
          step === 2 &&
          eventOptions.step1.subEventType.eventMovement === 'window' &&
          (eventOptions.step1.subEventType.movementType === 'self' ||
            eventOptions.step1.subEventType.movementType === 'open')
        "
        v-model="eventOptions.step3Public.useVariable"
        :url.sync="eventOptions.step3ByWindow.url"
        :componentVariables="eventOptions.step0.componentVariables"
        :eventVariables.sync="eventOptions.step1.eventVariables"
        @save="save"
      />
      <setScrollResponse
        v-else-if="step === 2 && eventOptions.step1.subEventType.eventMovement === 'window'"
        :position.sync="eventOptions.step3ByWindow.position"
        v-model="eventOptions.step3Public.useVariable"
        :componentVariables="eventOptions.step0.componentVariables"
        :eventVariables="eventOptions.step0.eventVariables"
        @save="save"
      />
      <setComponentShowResponse
        v-if="step === 3 && eventOptions.step1.subEventType.movementType === 'show'"
        :changeTo.sync="eventOptions.step3ByComponent.changeTo"
        :action.sync="eventOptions.step3ByComponent.action"
        :duration.sync="eventOptions.step3ByComponent.duration"
        :repeat.sync="eventOptions.step3ByComponent.repeat"
        :actionDes.sync="eventOptions.step3ByComponent.actionDes"
        :responseRectIds="eventOptions.step2ByComponent.responseRectIds"
        :innerElementLabel="innerElementLabel"
        @save="save"
      />
      <eventResponseSetting
        v-else-if="step === 3"
        :innerElementLabel="innerElementLabel"
        :eventUpdateType.sync="eventOptions.step3ByComponent.type"
        :transitionTime.sync="eventOptions.step3ByComponent.transitionTime"
        :option.sync="eventOptions.step3ByComponent.option"
        v-model="eventOptions.step3Public.useVariable"
        :componentVariables="eventOptions.step0.componentVariables"
        :eventVariables="eventOptions.step1.eventVariables"
        @save="save"
        :responseRectIds="eventOptions.step2ByComponent.responseRectIds"
      />
    </div>
  </div>
</template>

<script>
import chooseEvent from "./steps/chooseEvent.vue"
import eventSetting from "./steps/eventSetting.vue"
import chooseResponseComponent from "./steps/chooseResponseComponent.vue"
import eventResponseSetting from "./steps/eventResponseSetting.vue"
import setWindowResponse from "./steps/setWindowResponse.vue"
import setComponentShowResponse from "./steps/setComponentShowResponse.vue"
import setScrollResponse from "./steps/setScrollResponse.vue"
import editEvent from "./steps/editEvent.vue"
import { triggerTypes, EventLifeCycle } from "utils/event"
//在时间编辑框中的每一个步骤数据,结构如下所示👇
class eventOptions {
  constructor() {
    //步骤1主要会操作:
    //1:组件变量设置
    //2:事件触发方式(鼠标事件监听、数据变化监听)设置
    this.step0 = {
      //步骤1数据
      eventName: "", //click,mouseover,anyDataChange.......
      componentVariables: [
        // {
        //   variableName:'var1',
        //   variablePath:'options.content'
        // }
      ],
      variableTag: {} //需要监听的变量名
    }
    /**第一步主要会操作:
     * 1:事件变量设置,事件变量指的是事件回调函数的参数中的某个值,例如鼠标单击时,事件变量路径为offsetWidth,指的是鼠标事件监听里参数e的e.offsetWidth
     * 2.事件响应类型,目前有以下几种类型:组件配置项改变、组件显示隐藏动画、页面滚动、页面打开
     */
    this.step1 = {
      //步骤2数据
      eventVariables: [
        // {
        //   variableName:'var1',
        //   variablePath:'offsetWidth'
        // }
      ],
      subEventType: {
        eventMovement: "", //window,component>>页面事件，组件事件
        movementType: "" //组件时间类型：options,show,页面事件类型：self,open
      }
    }
    /**
     * 步骤2(组件配置项变化相应操作),主要配置响应该事件的组件的id
     */
    this.step2ByComponent = {
      responseRectIds: {
        //响应事件的组件id
        // container_id:1,
        // rect_id:1
      }
    }
    /**
     * 步骤3(页面):页面事件,用于存储页面打开时的url地址或者页面滚动时的滚动位置
     */
    this.step3ByWindow = {
      url: "", //打开页面的url：www.baidu.com
      position: [0, 0]
    }
    /**
     * 步骤3(组件响应):用于存储组件显示隐藏或者组件配置项变化的事件响应
     */
    this.step3ByComponent = {
      changeTo: "In", //in为显示 out为隐藏 exchange为显隐切换
      action: "fade",
      actionDes: "", //动作修饰符 例如fadeInLeft
      duration: 1,
      repeat: "0",
      //组件事件配置项用的
      type: "diff", //更新方式 diff为对比 force为全量替换
      transitionTime: null, //过渡动画时长,null代表不要过渡动画
      option: [] //响应该事件的组件的配置项
    }
    /**
     * 步骤3(公共):所有步骤3的公共属性
     */
    this.step3Public = {
      useVariable: []
      //window事件配置项用
      //显示隐藏事件配置项用的
    }
  }
  //reset开头的是初始化指定步骤数据的方法
  resetStep0Data() {
    this.step0.eventName = ""
    this.step0.componentVariables = []
    this.step0.variableTag = {}
  }
  resetStep1Data() {
    this.step1.eventVariables = []
    this.step1.subEventType = {
      eventMovement: "", //window,component>>页面事件，组件事件
      movementType: "" //组件时间类型：options,show,页面事件类型：self,open
    }
  }
  resetStep2PublicData() {
    this.step3Public.useVariable = []
  }
  resetStep2ByComponentData() {
    this.step2ByComponent.responseRectIds = {}
  }
  resetStep3ByWindowData() {
    this.step3ByWindow.url = ""
    this.step3ByWindow.position = [0, 0]
  }
  resetStep3ByComponentData() {
    this.step3ByComponent.changeTo = "In"
    this.step3ByComponent.action = "fade"
    this.step3ByComponent.duration = 1
    this.step3ByComponent.repeat = "0"
    this.step3ByComponent.actionDes = ""
    this.step3ByComponent.type = "diff"
    this.step3ByComponent.transitionTime = null
    this.step3ByComponent.option = []
  }
  //初始化所有步骤的方法
  resetAllOptions() {
    this.resetStep0Data()
    this.resetStep1Data()
    this.resetStep2PublicData()
    this.resetStep2ByComponentData()
    this.resetStep3ByWindowData()
    this.resetStep3ByComponentData()
  }
}

export default {
  components: {
    chooseEvent, //选择事件触发方式
    eventSetting, //选择事件响应类型
    chooseResponseComponent, //选中响应事件的组件
    eventResponseSetting, //设置响应事件的组件所需变化的配置项
    setWindowResponse, //配置浏览器页面打开事件
    setComponentShowResponse, //配置组件显示隐藏事件
    setScrollResponse, //设置页面滚动事件
    editEvent //事件列表回显及事件生命周期 事件组的配置
  },
  data() {
    return {
      eventOptions: new eventOptions(),
      step: 0,
      innerElementLabel: "",
      activeRectIds: null,
      tarEvent: null,
      delParam: null,
      isEditEvent: false,
      primarySelectValue: undefined,
      changeIdByComponentSet: false
    }
  },
  watch: {
    "eventOptions.step0.eventName"(n, o) {
      if (n.length && this.step !== 1) {
        //如果事件为变量事件 那必须先选择变量,并选择变量响应类型
        if (n !== "appointDataChange" && !this.isEditEvent) {
          this.step = 1
        }
      }
    },
    "$store.state.states.activeID": {
      deep: true,
      handler(n, o) {
        //如果在事件编辑时 点击了画布上的其他组件 就会初始化事件编辑框，只有是选择响应组件时修改activeID才不会初始化
        if (!(this.step === 3 && this.changeIdByComponentSet)) {
          this.eventOptions.resetAllOptions()
          this.init()
        }
      }
    },
    "eventOptions.step1.subEventType": {
      deep: true,
      handler(n, o) {
        //步骤一选择好触发事件的方式后,进入步骤二
        if (n.eventMovement.length && n.movementType.length && !this.isEditEvent) {
          this.step = 2
        }
      }
    },
    "eventOptions.step2ByComponent.responseRectIds": {
      deep: true,
      handler(n, o) {
        //步骤二选择好响应事件的组件后,进入步骤三
        if (Object.keys(n).length && !this.isEditEvent) {
          this.step = 3
          this.setStep3()
        }
      }
    },
    step: {
      immediate: true,
      handler(n, o) {
        //在初始化事件相应类型页面时,初始化一次组件变量
        if (n === 0) this.initComponentVariables()
      }
    }
  },
  methods: {
    //在交互列表中,二次编辑事件
    editEventEv(param) {
      //isEditEvent为true,用于在接下来对保存好的事件初始化的过程中,不会触发原有从零新建事件的响应副作用
      this.isEditEvent = true
      //先把当前事件的组件变量保存起来,再初始化所有eventOptions
      let componentVariables = this.eventOptions.step0.componentVariables
      if (componentVariables.length === 0) {
        if (JSON.stringify(param.event.variableTag) !== "{}") {
          for (let key in param.event.variableTag) {
            componentVariables.push({
              variablePath: param.event.variableTag[key].path,
              variableName: key
            })
          }
        }else{
          const { tar } = this.$event.findTar({ ...this.getActiveIds() })
          if (tar) {
            componentVariables = tar.componentVariables
          }
        }
      }
      this.eventOptions.resetAllOptions()
      this.eventOptions.step0.componentVariables = componentVariables
      const { eventType, eventNameDes, event, elementType, index } = param
      this.delParam = {
        eventId: event.id,
        lifeCycle: event.lifeCycle,
        eventType,
        index,
        eventName: eventNameDes
      }
      this.innerElementLabel = elementType
      const { eventMovement, movementType } = event
      //初始化所有事件都需要的配置项
      this.initPublicEditEvent(event, param, this.eventOptions)
      //根据编辑的事件的类型,分别初始化对应配置项
      if (eventMovement === "component" && movementType === "options") {
        this.editComponentOptionEvent(event, this.eventOptions)
        this.step = 3
        this.setStep3()
      } else if (eventMovement === "component" && movementType === "show") {
        this.editComponentShowEvent(event, this.eventOptions)
        this.step = 3
        this.setStep3()
      } else if (eventMovement === "window" && (movementType === "open" || movementType === "self")) {
        //初始化window事件
        this.editWindowEvent(event, this.eventOptions)
        this.step = 2
      } else if (eventMovement === "window" && (movementType === "scroll" || movementType === "scrollBy")) {
        //初始化页面滚动事件
        this.editScrollEvent(event, this.eventOptions)
        this.step = 2
      }
      this.$nextTick(() => {
        this.isEditEvent = false
      })
    },
    setStep3() {
      this.changeIdByComponentSet = true
      this.$nextTick(() => {
        this.changeIdByComponentSet = false
      })
    },
    //初始化编辑事件过程中,公共的事件描述
    initPublicEditEvent(event, param, opt) {
      event.eventType = param.eventType
      opt.step0.eventName = param.eventNameDes
      opt.step1.subEventType.eventMovement = event.eventMovement
      opt.step1.subEventType.movementType = event.movementType
      let nameStr = event.eventName
      if(!event.eventName){
        nameStr = param.eventNameDes
      }
      if (event.eventType === "dataEvents" && nameStr === "appointDataChange") {
        opt.step0.variableTag = event.variableTag
      }
    },
    //初始化编辑组件配置项变化事件
    editComponentOptionEvent(event, opt) {
      opt.step1.eventVariables = event.eventVariables ? this.cloneVariable(event.eventVariables) : [] //初始化组件变量
      opt.step3ByComponent.type = event.update.type
      opt.step3ByComponent.transitionTime = event.update.transitionTime
      opt.step3ByComponent.option = event.update.option
      opt.step2ByComponent.responseRectIds = { ...event.ids }
      opt.step3Public.useVariable = this.cloneVariable(event.update.useVariable)
    },
    //初始化 编辑组件显隐事件
    editComponentShowEvent(event, opt) {
      opt.step3ByComponent.changeTo = event.changeTo
      opt.step3ByComponent.action = event.action
      opt.step3ByComponent.duration = event.duration
      opt.step3ByComponent.repeat = event.repeat
      opt.step3ByComponent.actionDes = event.actionDes
      opt.step2ByComponent.responseRectIds = event.ids
      //组件显示隐藏啥也不用做
    }, //初始化 编辑页面打开事件
    editWindowEvent(event, opt) {
      opt.step3ByWindow.url = event.url
      opt.step3Public.useVariable = this.cloneVariable(event.useVariable) //初始化使用的变量
    },
    //初始化 编辑页面滚动事件
    editScrollEvent(event, opt) {
      opt.step3ByWindow.position = event.position
      opt.step3Public.useVariable = this.cloneVariable(event.useVariable) //初始化使用的变量
    },
    //初始化当前组件的事件,回到首页(交互列表页或者新建交互页)
    initCurrEvent() {
      const { tar, idsStr } = this.$event.findTar({ ...this.getActiveIds() })
      if (tar) {
        const { mouseEvents, dataEvents } = tar.events
        const check = ev => Object.keys(ev).some(k => ev[k].length)
        if (check(mouseEvents) || check(dataEvents)) {
          //当前组件已经有事件了 需要进行已有事件回显
          this.step = -1
          this.tarEvent = tar
        } else {
          this.step = 0
          this.tarEvent = null
        }
      } else {
        this.step = 0
        this.tarEvent = null
      }
    },
    createEventEv() {
      this.step = 0
    },
    getActiveIds() {
      const res = {}
      const ids = this.$store.state.states.activeID
      Object.keys(ids).forEach(k => {
        if (ids[k] !== null) res[k] = ids[k]
      })
      this.activeRectIds = res
      return res
    },
    getResponseElId(ids) {
      for (let k in ids) {
        if (ids[k] === null) {
          delete ids[k]
        }
      }
      const base = ["container_id", "rect_id"]
      const elementInLayoutSort = ["uid", "elementInLayoutId"]
      const elementInSwiperSort = ["swiperContent_id", "elementInSwiperId"]
      if (ids.hasOwnProperty("elementInLayoutId")) {
        return [...base, ...elementInLayoutSort].map(k => k + "_" + ids[k]).join("-")
      } else if (ids.hasOwnProperty("elementInSwiperId")) {
        return [...base, ...elementInSwiperSort].map(k => k + "_" + ids[k]).join("-")
      } else {
        return [...base].map(k => k + "_" + ids[k]).join("-")
      }
    },
    cloneVariable(variable) {
      return variable
        .map(item => {
          if (Object.keys(item).every(k => typeof item[k] === "string" && item[k].length)) {
            return { ...item }
          } else return { ...JSON.parse(JSON.stringify(item)) }
        })
        .filter(item => item)
    },
    activeRectIdsFilter(ids) {
      const _ids = { ...ids }
      delete _ids.pageId
      if (
        Object.keys(_ids).length === 3 &&
        _ids.hasOwnProperty("container_id") &&
        _ids.hasOwnProperty("rect_id") &&
        _ids.hasOwnProperty("swiperContent_id")
      ) {
        delete _ids.swiperContent_id
      }
      return _ids
    },
    //保存事件时,初始化所有类型事件公共的事件配置项
    initEvent(event, opt) {
      event.publishComponentIds = { ...this.activeRectIdsFilter(this.activeRectIds) } //初始化当前组件id
      const elClassName = this.getResponseElId({ ...event.publishComponentIds })
      const echartsEl = document.getElementsByClassName(elClassName)[0].getElementsByClassName("echarts")[0]
      event.type = echartsEl ? "echarts" : "normal" //初始化组件类型
      event.componentVariables = this.cloneVariable(opt.step0.componentVariables) //初始化组件变量
      event.eventType = triggerTypes[opt.step0.eventName] + "Events" //初始化事件响应类型,component事件还是window事件
      event.eventName = opt.step0.eventName
      event.eventMovement = opt.step1.subEventType.eventMovement
      event.movementType = opt.step1.subEventType.movementType
      event.lifeCycle = new EventLifeCycle()
      if (event.eventType === "dataEvents" && event.eventName === "appointDataChange") {
        event.variableTag = opt.step0.variableTag
      }
    },
    initComponentOptionEvent(event, opt) {
      event.eventVariables = this.cloneVariable(opt.step1.eventVariables) //初始化组件变量
      event.responseRectIds = { ...opt.step2ByComponent.responseRectIds }
      event.update = {
        type: opt.step3ByComponent.type,
        transitionTime: opt.step3ByComponent.transitionTime, //过渡动画时长,null代表不要过渡动画
        option: opt.step3ByComponent.option, //响应该事件的组件的配置项
        useVariable: this.cloneVariable(opt.step3Public.useVariable) //初始化组件使用变量
      }
    },
    initComponentShowEvent(event, opt) {
      event.changeTo = opt.step3ByComponent.changeTo
      event.action = opt.step3ByComponent.action
      event.duration = opt.step3ByComponent.duration
      event.repeat = opt.step3ByComponent.repeat
      event.actionDes = opt.step3ByComponent.actionDes
      event.ids = { ...opt.step2ByComponent.responseRectIds }
    },
    initWindowEvent(event, opt) {
      event.url = opt.step3ByWindow.url
      event.useVariable = this.cloneVariable(opt.step3Public.useVariable) //初始化使用的变量
    },
    initScrollEvent(event, opt) {
      event.position = opt.step3ByWindow.position
      event.useVariable = this.cloneVariable(opt.step3Public.useVariable) //初始化使用的变量
    },
    save() {
      const event = {}
      try {
        const eventOptions = JSON.parse(JSON.stringify(this.eventOptions))
        //初始化通用的配置项
        this.initEvent(event, eventOptions)
        const { eventMovement, movementType } = event
        //初始化组件配置项事件
        if (eventMovement === "component" && movementType === "options") {
          //初始化组件配置项响应事件的事件描述
          this.initComponentOptionEvent(event, eventOptions)
          this.eventEditControl(event, "componentOption")
        } else if (eventMovement === "component" && movementType === "show") {
          //初始化组件显示隐藏事件
          this.initComponentShowEvent(event, eventOptions)
          this.eventEditControl(event, "componentShow")
        } else if (eventMovement === "window" && (movementType === "open" || movementType === "self")) {
          //初始化window事件
          this.initWindowEvent(event, eventOptions)
          this.eventEditControl(event, "window")
        } else if (eventMovement === "window" && (movementType === "scroll" || movementType === "scrollBy")) {
          //初始化页面滚动事件
          this.initScrollEvent(event, eventOptions)
          this.eventEditControl(event, "scroll")
        }
        this.eventOptions.resetAllOptions()
        this.$store.commit("states/changeActiveID", this.activeRectIds)
        this.isEditEvent = false
      } catch (error) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "保存失败"
        })
        this.primarySelectValue = undefined
      } finally {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "success",
          message: "保存成功"
        })
        this.primarySelectValue = {
          eventType: event.eventType,
          eventName: event.eventName
        }
        this.initCurrEvent()
      }
    },
    eventEditControl(event, type) {
      this.$event.add(
        event,
        type,
        this.delParam ? { publishComponentIds: { ...this.activeRectIds }, ...this.delParam } : null
      )
      this.delParam = null
    },
    /**
     * @param {Number} step 要跳回到那一步去
     */
    backStep(step) {
      this.step--
      switch (step) {
        case -1:
          !this.isEditEvent && this.eventOptions.resetStep0Data()
          break
        case 0:
          !this.isEditEvent && this.eventOptions.resetStep1Data()
          break
        case 1:
          if (!this.isEditEvent) {
            this.eventOptions.resetStep2PublicData()
            if (this.eventOptions.step1.subEventType.eventMovement === "window") {
              !this.isEditEvent && this.eventOptions.resetStep3ByWindowData()
            } else {
              //将选中组件的id改回当前选中组件的ids
              !this.isEditEvent && this.eventOptions.resetStep2ByComponentData()
              this.$store.commit("states/changeActiveID", this.activeRectIds)
            }
          }
          break
        case 2:
          !this.isEditEvent && this.eventOptions.resetStep3ByComponentData()
          break
        default:
          break
      }
    },
    initComponentVariables() {
      const { tar: tarEvent, idsStr } = this.$event.findTar({ ...this.getActiveIds() })
      // 如果找到了 证明之前注册过事件 则继续 否则退出
      if (tarEvent?.componentVariables?.length) {
        this.eventOptions.step0.componentVariables = this.cloneVariable(tarEvent.componentVariables)
      }
    },
    init() {
      // Object.values(this.$event.eventBus)[0].events.mouseEvents.mouseout = []
      //保存一下当前选中组件的id
      this.getActiveIds()
      //初始化组件变量
      this.initCurrEvent()
    }
  },
  created() {
    this.init()
  }
}
</script>
<style>
.save_box {
  padding: 0 24px;
}
.save_box.padding0 {
  padding: 0;
}
.save_edit {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 70px;
}
.save_edit:hover {
  cursor: pointer;
}
.event-title-label-box {
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.event-title-label-box-hover:hover {
  cursor: pointer;
}
.event-label-title {
  border-top: 1px solid var(--borderColorEle);
  padding: 16px 24px;
  background: var(--elCollapseItemHeaderBgColor) !important;
  color: var(--elCollapseItemHeaderColor) !important;
}
</style>
<style scoped>
.back_icon {
  vertical-align: middle;
}
</style>
